// extracted by mini-css-extract-plugin
export default {"app":"App_app__gLhyc","logo-heading":"App_logo-heading__QbB8M","header":"App_header__VuShw","bottom-fade":"App_bottom-fade__z+wUM"};